import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import AdminView from '@/views/AdminView.vue'
import PenaleDashboardView from '@/views/PenaleDashboardView.vue'
import PenalePercorsoView from '@/views/PenalePercorsoView.vue'
import AnalisiView from "@/views/AnalisiView.vue";
import CookieView from "@/views/CookieView.vue";
import FamigliaPercorsoView from '@/views/FamigliaPercorsoView.vue'
import FamigliaDashboardView from '@/views/FamigliaDashboardView.vue'
import ResponsabilitaPercorsoView from '@/views/ResponsabilitaPercorsoView.vue'
import ResponsabilitaDashboardView from '@/views/ResponsabilitaDashboardView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/penale/percorso',
      name: 'pen_percorso',
      component: PenalePercorsoView
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      //component: () => import('../views/PercorsoView.vue')
    },
    {
      path: '/penale/dashboard',
      name: 'pen_dashboard',
      component: PenaleDashboardView //() => import('../views/DashboardView.vue')
    },
    {
      path: '/analisi',
      name: 'analisi',
      component: AnalisiView //() => import('../views/DashboardView.vue')
    },
    {
      path: '/admin',
      name: 'admin',
      component: AdminView
    },
    {
      path: '/famiglia/percorso',
      name: 'fam_percorso',
      component: FamigliaPercorsoView
    },
    {
      path: '/famiglia/dashboard',
      name: 'fam_dashboard',
      component: FamigliaDashboardView
    },
    {
      path: '/responsabilita/percorso',
      name: 'res_percorso',
      component: ResponsabilitaPercorsoView
    },
    {
      path: '/responsabilita/dashboard',
      name: 'res_dashboard',
      component: ResponsabilitaDashboardView
    },
    {
      path: '/cookie',
      name: 'cookie',
      component: CookieView //() => import('../views/DashboardView.vue')
    }

  ]
})

export default router